export enum Accessor {
  Index = 'index',
  VendorName = 'vendorName',
  AssetCode = 'assetCode',
  LocationCode = 'locationCode',
  Quantity = 'qty',
  Sku = 'sku',
  Price = 'price',
}
